import type { ModuleDefinition } from 'ag-charts-core';

import { AnimationModule } from '../features/animation/animationModule';
import { AnnotationsModule } from '../features/annotations/annotationsModule';
import { AxisInteractionModule } from '../features/axis-interaction/axisInteractionModule';
import { BandHighlightModule } from '../features/band-highlight/bandHighlightModule';
import { ChartToolbarModule } from '../features/chart-toolbar/chartToolbarModule';
import { ContextMenuModule } from '../features/context-menu/contextMenuModule';
import { CrosshairModule } from '../features/crosshair/crosshairModule';
import { SelectionModule } from '../features/data-selection/dataSelectionModule';
import { DataSourceModule } from '../features/data-source/dataSourceModule';
import { ErrorBarsModule } from '../features/error-bar/errorBarModule';
import { FlashOnUpdateModule } from '../features/flash-on-update/flashOnUpdateModule';
import { NavigatorModule } from '../features/navigator/navigatorModule';
import { RangesModule } from '../features/ranges/rangesModule';
import { ScrollbarModule } from '../features/scrollbar/scrollbarModule';
import { StatusBarModule } from '../features/status-bar/statusBarModule';
import { SyncModule } from '../features/sync/syncModule';
import { ZoomModule } from '../features/zoom/zoomModule';
import { GradientLegendModule } from '../gradient-legend/gradientLegendModule';
import { AllCartesianAxesModule } from './cartesian-axes';
import { AllCartesianSeriesModule } from './cartesian-series';

export const AllCartesianModule: ModuleDefinition[] = [
    AllCartesianAxesModule,
    AllCartesianSeriesModule,

    AnimationModule,
    AnnotationsModule,
    AxisInteractionModule,
    BandHighlightModule,
    ChartToolbarModule,
    ContextMenuModule,
    CrosshairModule,
    DataSourceModule,
    ErrorBarsModule,
    FlashOnUpdateModule,
    GradientLegendModule,
    NavigatorModule,
    RangesModule,
    ScrollbarModule,
    SelectionModule,
    StatusBarModule,
    SyncModule,
    ZoomModule,
].flat();
